// extracted by mini-css-extract-plugin
export default {"zr-switch":"ToggleSwitch_zr-switch__SETRN","slider":"ToggleSwitch_slider__BKnYq","checked":"ToggleSwitch_checked__OBKsV","label-text":"ToggleSwitch_label-text__Yb1aF"};